import React, { useEffect } from 'react';
import { Container, Row, Col, Button, Spinner } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { FaExchangeAlt, FaArrowDown, FaArrowUp, FaWallet } from 'react-icons/fa';
import useWallet from '../hooks/useWallet';
import useOtcMarketplace from '../hooks/useOtcMarketplace';
import PhaseCard from '../components/otc/PhaseCard';
import './OtcMarketplace.css';

const OtcMarketplace = () => {
  const navigate = useNavigate();
  const {
    address,
    signer,
    isConnected,
    isConnecting,
    connect,
    disconnect,
    formatAddress,
    isCorrectNetwork,
    switchToSonic,
  } = useWallet();
  const { sellPhases, buyPhases } = useOtcMarketplace(signer);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handlePhaseClick = (mode, phase) => {
    if (phase.isActive) {
      navigate(`/otc/${mode}`, { state: { phase } });
    }
  };

  return (
    <div className="otc-marketplace">
      <section className="otc-hero">
        <Container>
          <div className="otc-header text-center">
            <div className="otc-badge" data-aos="fade-up">
              <FaExchangeAlt className="me-2" />
              <span>MCGP Onchain OTC Marketplace</span>
            </div>

            <h1 className="otc-title" data-aos="fade-up" data-aos-delay="100">
              Buy / Sell <span className="gradient-text">MCGP</span>
            </h1>

            <p className="otc-subtitle" data-aos="fade-up" data-aos-delay="200">
              Trade MCGP tokens at preset price phases. Instant swaps with USDC.
            </p>

            {/* Wallet Connection */}
            <div className="wallet-section" data-aos="fade-up" data-aos-delay="250">
              {!isConnected ? (
                <Button
                  className="connect-wallet-btn"
                  onClick={connect}
                  disabled={isConnecting}
                >
                  {isConnecting ? (
                    <>
                      <Spinner size="sm" className="me-2" />
                      Connecting...
                    </>
                  ) : (
                    <>
                      <FaWallet className="me-2" />
                      Connect Wallet to View Phases
                    </>
                  )}
                </Button>
              ) : !isCorrectNetwork ? (
                <Button className="switch-network-btn" onClick={switchToSonic}>
                  Switch to Sonic Network
                </Button>
              ) : (
                <div className="connected-wallet">
                  <FaWallet className="me-2" />
                  <span>{formatAddress(address)}</span>
                  <button className="disconnect-btn" onClick={disconnect}>
                    Disconnect
                  </button>
                </div>
              )}
            </div>
          </div>

          <Row className="justify-content-center">
            {/* Sell MCGP Column */}
            <Col lg={5} md={6} className="mb-4">
              <div
                className="phase-section sell-section"
                data-aos="fade-right"
                data-aos-delay="300"
              >
                <div className="section-header">
                  <FaArrowDown className="section-icon sell-icon" />
                  <h2>Sell MCGP</h2>
                  <p className="section-subtitle">
                    Price phases from presale price of $0.01
                  </p>
                </div>

                <div className="phases-list">
                  {sellPhases.map((phase) => (
                    <PhaseCard
                      key={phase.index}
                      phase={phase}
                      mode="sell"
                      onClick={() => handlePhaseClick('sell', phase)}
                    />
                  ))}
                </div>
              </div>
            </Col>

            {/* Buy MCGP Column */}
            <Col lg={5} md={6} className="mb-4">
              <div
                className="phase-section buy-section"
                data-aos="fade-left"
                data-aos-delay="300"
              >
                <div className="section-header">
                  <FaArrowUp className="section-icon buy-icon" />
                  <h2>Buy MCGP</h2>
                  <p className="section-subtitle">
                    Price phases from presale price of $0.01
                  </p>
                </div>

                <div className="phases-list">
                  {buyPhases.map((phase) => (
                    <PhaseCard
                      key={phase.index}
                      phase={phase}
                      mode="buy"
                      onClick={() => handlePhaseClick('buy', phase)}
                    />
                  ))}
                </div>
              </div>
            </Col>
          </Row>

          <div
            className="otc-info text-center mt-5"
            data-aos="fade-up"
            data-aos-delay="500"
          >
            <p>
              <strong>Note:</strong> Swaps are instant. Only the active phase is
              available for trading. New phases unlock as liquidity is added.
            </p>
          </div>
        </Container>
      </section>
    </div>
  );
};

export default OtcMarketplace;
